<mat-card appearance="outlined" class="impersonate-dialog-wrapper">
    <div class="popup-header logo flex">
        <i class="fa fa-user-secret" aria-hidden="true"></i>
        <h4>&nbsp; Impersonating: {{ userForApi }}</h4>
        <mat-divider class="divider" [vertical]="true"></mat-divider>
        <button class="release-buttons" mat-button (click)="forgetUser()">Forget</button>
    </div>
</mat-card>
